import React, { Dispatch, FC, SetStateAction, useContext } from 'react';

import { TargetApplication } from '@asa/asasqt-microfrontend-components/dist/common/types/shared/auth';
import { useAuthentication } from '@asa/asasqt-microfrontend-components/dist/hooks/auth/useAuthentication';
import { useAuthorization } from '@asa/asasqt-microfrontend-components/dist/hooks/auth/useAuthorization';

import { USER_24_SERVICES } from '@/core/common/api/ilias';
import { useAxiosIntercept } from '@/core/common/axios/axios.context';
import { LanguageContext } from '@/core/common/language';

import { useUserServices } from '../../common/hooks/useUserServices';
import { authorizationHookTranslations } from '../utils/auth.const';

export declare type AuthContextType = {
  isAuthenticated: boolean;
  setIsAuthenticated?: Dispatch<SetStateAction<boolean | undefined>>;
  userServices: TODO; //sync from @asa-components
  loadAuthorizationData: TODO;
};

export const AuthContext = React.createContext<AuthContextType>(null as TODO);
export const AuthProvider: FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => {
  const { tr } = useContext(LanguageContext);
  const axiosIntercept = useAxiosIntercept();

  const t = authorizationHookTranslations(tr);

  const { isAuthenticated } = useAuthentication({
    axiosIntercept,
    t,
    USER_24_SERVICES,
    targetApp: TargetApplication.ASA_SQT,
  });
  const { userServices } = useUserServices();
  const { loadAuthorizationData } = useAuthorization({
    axiosIntercept,
    t,
    USER_24_SERVICES,
  });

  return (
    <>
      <AuthContext.Provider
        value={{
          isAuthenticated,
          userServices,
          loadAuthorizationData,
        }}
      >
        {children}
      </AuthContext.Provider>
    </>
  );
};
